import GiftSummaryPage from "views/GiftSummary";
import React from "react";
import { createBrowserRouter } from "react-router-dom";

import NotFoundPage from "views/404NotFound";
import LoginPage from "views/Auth";
import BannersPage from "views/Banners";
import CollectPointsPage from "views/CollectPoints";
import DashboardPage from "views/Dashboard";
import GeneralSettingsPage from "views/GeneralSettings";
import HelpCentersPage from "views/HelpCenters";
import MediaPage from "views/Media";
import MemberActivityPage from "views/MemberActivity";
import MembersPage from "views/Members";
import MembershipSummaryPage from "views/MembershipSummary";
import TenantsPage from "views/Tenant";
import { TierRewardsPage, TiersPage } from "views/Tiers";
import UsersPage from "views/Users";
import VouchersPage from "views/Vouchers";
import WarrantiesPage from "views/Warranties";
import LogActivityPage from "views/LogActivity";
import PointActivityPage from "views/PointActivity";
import RedeemActivityPage from "views/RedeemActivity";
import OcrActivityPage from "views/OcrActivity";
import CatalogsEthPage from "views/CatalogEth";
import { getRole, getTenant } from "hooks";
import RewardShipmentsPage from "views/RewardShipments";
import RaffleOcrActivityPage from "views/RaffleOcrActivity";
import RafflesPage from "views/Raffles";
import RaffleWinnersPage from "views/RaffleWinners";
import { CatalogGiftsPage, CatalogsPage } from "views/Catalogs";
import RaffleEventsPage from "views/RaffleEvents";
import RaffleMerchantsPage from "views/RaffleMerchantsPage";
import RaffleActivityPage from "views/RaffleActivity";
import UltraRewardPage from "views/UltraReward";
import UserComplaintPage from "views/UserComplaint";
import RaffleAncolPage from "views/RaffleAncol";
import RaffleAncolMonthly from "views/RaffleAncolMonthly";
import QuestsPage from "views/Quests";

const userRole = getRole();
const userTenant = getTenant();

const isSuperAdmin = userRole === "superadmin";
const isAdmin = userRole === "admin";
const isPartner = userRole === "partner";
const isUltraMilkTenant = userTenant === "Ultra Milk";
const isBatTenant = userTenant === "BAT";

const Router = createBrowserRouter([
  {
    path: "login",
    element: <LoginPage />,
  },

  {
    path: "/",
    element: isSuperAdmin || isAdmin ? <DashboardPage /> : <RaffleAncolMonthly />,
  },

  {
    path: "analytics/ultra-reward",
    element:
      isSuperAdmin || isAdmin ? <UltraRewardPage /> : <NotFoundPage />,
  },

  {
    path: "analytics/raffle-activity",
    element:
      isSuperAdmin || isAdmin ? <RaffleActivityPage /> : <NotFoundPage />,
  },
  {
    path: "analytics/membership-summary",
    element:
      isSuperAdmin || isAdmin ? <MembershipSummaryPage /> : <NotFoundPage />,
  },
  {
    path: "analytics/member-activity-summary",
    element:
      isSuperAdmin || isAdmin ? <MemberActivityPage /> : <NotFoundPage />,
  },
  {
    path: "analytics/gift-summary",
    element: isSuperAdmin || isAdmin ? <GiftSummaryPage /> : <NotFoundPage />,
  },

  {
    path: "members/list",
    element: <MembersPage />,
  },

  {
    path: "tiers",
    element: isSuperAdmin || isAdmin ? <TiersPage /> : <NotFoundPage />,
  },
  {
    path: "tiers/rewards/:tierName",
    element: isSuperAdmin || isAdmin ? <TierRewardsPage /> : <NotFoundPage />,
  },

  {
    path: "products/catalogs",
    element: <CatalogsPage />,
  },
  {
    path: "products/vouchers",
    element: <VouchersPage />,
  },
  {
    path: "products/eth",
    element:
      isSuperAdmin || (isAdmin && isUltraMilkTenant) ? (
        <CatalogsEthPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "products/gifts/:catalogId",
    element: <CatalogGiftsPage />,
  },
  {
    path: "raffle-ancol",
    element:
      isSuperAdmin || isAdmin || isPartner ? (
        <RaffleAncolPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "raffle-ancol-monthly",
    element:
      isSuperAdmin || isAdmin || isPartner ? (
        <RaffleAncolMonthly />
      ) : (
        <NotFoundPage />
      ),
  },

  {
    path: "reward-shipments",
    element:
      isSuperAdmin || isAdmin || isUltraMilkTenant ? (
        <RewardShipmentsPage />
      ) : (
        <NotFoundPage />
      ),
  },

  {
    path: "activity/user-complaint",
    element:
      isSuperAdmin || isAdmin || isUltraMilkTenant ? (
        <UserComplaintPage />
      ) : (
        <NotFoundPage />
      ),
  },

  {
    path: "activity/log-activities",
    element:
      isSuperAdmin || isAdmin ? (
        <LogActivityPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "activity/point-activities",
    element:
      isSuperAdmin || isAdmin ? (
        <PointActivityPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "activity/ocr-activities",
    element:
      isSuperAdmin || isAdmin ? (
        <OcrActivityPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "activity/redeem-activities",
    element:
      isSuperAdmin || isAdmin ? (
        <RedeemActivityPage />
      ) : (
        <NotFoundPage />
      ),
  },

  {
    path: "raffles/ocr-activities",
    element:
      isSuperAdmin || (isAdmin && isUltraMilkTenant) ? (
        <RaffleOcrActivityPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "raffles/list",
    element:
      isSuperAdmin || (isAdmin && isUltraMilkTenant) ? (
        <RafflesPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "raffles/winners",
    element:
      isSuperAdmin || (isAdmin && isUltraMilkTenant) ? (
        <RaffleWinnersPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "raffles/events",
    element:
      isSuperAdmin || (isAdmin && isUltraMilkTenant) ? (
        <RaffleEventsPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "raffles/merchants",
    element:
      isSuperAdmin || (isAdmin && isUltraMilkTenant) ? (
        <RaffleMerchantsPage />
      ) : (
        <NotFoundPage />
      ),
  },

  {
    path: "collect-points",
    element:
      isSuperAdmin || (isAdmin && isBatTenant) || isBatTenant ? (
        <CollectPointsPage />
      ) : (
        <NotFoundPage />
      ),
  },

  {
    path: "warranties",
    element:
      isSuperAdmin || (isAdmin && isBatTenant) || isBatTenant ? (
        <WarrantiesPage />
      ) : (
        <NotFoundPage />
      ),
  },

  {
    path: "account/users",
    element: isSuperAdmin ? <UsersPage /> : <NotFoundPage />,
  },
  {
    path: "account/tenants",
    element: isSuperAdmin ? <TenantsPage /> : <NotFoundPage />,
  },

  {
    path: "config/banners",
    element:
      isSuperAdmin || isAdmin  || isBatTenant ? (
        <BannersPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "config/media",
    element:
      isSuperAdmin || (isAdmin && isBatTenant) || isBatTenant ? (
        <MediaPage />
      ) : (
        <NotFoundPage />
      ),
  },
  {
    path: "config/general-settings",
    element:
      isSuperAdmin || isAdmin ? <GeneralSettingsPage /> : <NotFoundPage />,
  },
  {
    path: "config/help-center",
    element:
      isSuperAdmin || (isAdmin && isBatTenant) || isBatTenant ? (
        <HelpCentersPage />
      ) : (
        <NotFoundPage />
      ),
  },

  {
    path: "quests",
    element:
      isSuperAdmin || isAdmin ? (
        <QuestsPage />
      ) : (
        <NotFoundPage />
      ),
  },

  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default Router;
